import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useGetLocalDevicesQuery } from "../store/api";

const ENV_DEVICE_ID = process.env.REACT_APP_DEVICE_ID || "";
const ENV_DEVICE_KEY =
  process.env.REACT_APP_DEVICE_KEY || process.env.REACT_APP_DEVICE_TOKEN || "";

const pickDevice = (devices, preferredKey, preferredId) => {
  if (!Array.isArray(devices) || devices.length === 0) return null;
  if (preferredId) {
    const match = devices.find((d) => d.deviceId === preferredId);
    return match || null;
  }
  if (preferredKey) {
    const match = devices.find((d) => d.deviceKey === preferredKey);
    return match || null;
  }
  return null;
};

export const useDeviceIdentity = (enabled = true) => {
  const token = useSelector((state) => state.auth.token);
  const shouldSkip = !enabled || !token;
  const query = useGetLocalDevicesQuery(undefined, { skip: shouldSkip });

  const device = useMemo(() => {
    const preferredKey = localStorage.getItem("edgeDeviceToken") || ENV_DEVICE_KEY;
    const preferredId = localStorage.getItem("edgeDeviceId") || ENV_DEVICE_ID;
    return pickDevice(query.data, preferredKey, preferredId);
  }, [query.data]);

  return {
    ...query,
    device,
  };
};
